const products = [
  {
    id: 1,
    name: "Morning Roast",
    category: "Coffee",
    price: 18,
    rating: 4.8,
    badge: "Best Seller",
    image: "/images/products/coffee1.jpg",
  },
  {
    id: 2,
    name: "The Kinfolk Home",
    category: "Books",
    price: 34,
    rating: 5,
    badge: "New",
    image: "/images/products/book1.jpg",
  },
  {
    id: 3,
    name: "Minimal Linen Shirt",
    category: "Apparel",
    price: 62,
    rating: 4.9,
    badge: "Popular",
    image: "/images/products/shirt1.jpg",
  },
  {
    id: 4,
    name: "Monstera Deliciosa",
    category: "Greens",
    price: 42,
    rating: 4.7,
    badge: "Trending",
    image: "/images/products/plant1.jpg",
  },
];

export default products;